// Tutorial em HTML dos processos do Siga: montagem da página com as figuras incorporadas,
// exibição isolada (iframe) e a regra de quais processos pertencem à tela.

const EXTENSOES_IMAGEM = /\.(png|jpe?g|gif|webp|svg|avif)$/i;

function nomeArquivo(caminho) {
  const limpo = String(caminho || "").split(/[?#]/)[0];
  try {
    return decodeURIComponent(limpo.split("/").pop()).toLowerCase();
  } catch (e) {
    return limpo.split("/").pop().toLowerCase();
  }
}

function referenciaExterna(valor) {
  return /^(data:|https?:|\/\/|#|blob:)/i.test(String(valor || "").trim());
}

// Troca as referências às imagens (src="img/figura.png", url(img/fundo.png)) pelo conteúdo delas,
// casando pelo nome do arquivo. Devolve o HTML e o que não foi encontrado entre as imagens enviadas.
export function montarConteudoTutorial(html, imagens = []) {
  const porNome = new Map(
    imagens.map((imagem) => [nomeArquivo(imagem.nome), imagem.dataUrl])
  );
  const incorporadas = new Set();
  const faltando = new Set();
  const trocar = (valor) => {
    if (referenciaExterna(valor)) return null;
    const nome = nomeArquivo(valor);
    if (porNome.has(nome)) {
      incorporadas.add(nome);
      return porNome.get(nome);
    }
    if (EXTENSOES_IMAGEM.test(nome)) faltando.add(nome);
    return null;
  };
  const conteudo = String(html || "")
    .replace(
      /(\bsrc\s*=\s*)(["'])([^"']*)\2/gi,
      (trecho, inicio, aspas, valor) => {
        const novo = trocar(valor);
        return novo ? `${inicio}${aspas}${novo}${aspas}` : trecho;
      }
    )
    .replace(/url\(\s*(["']?)([^"')]+)\1\s*\)/gi, (trecho, aspas, valor) => {
      const novo = trocar(valor);
      return novo ? `url(${aspas}${novo}${aspas})` : trecho;
    });
  return {
    conteudo,
    incorporadas: [...incorporadas],
    faltando: [...faltando],
  };
}

// Links externos abrem em outra aba. Âncoras (#secao) rolam até a seção: no iframe srcdoc o
// endereço base é o do Cajupe, e o link levaria o quadro para fora do tutorial.
const SCRIPT_LINKS = `<script>document.addEventListener("click",function(e){var a=e.target.closest&&e.target.closest("a[href]");if(!a)return;var h=a.getAttribute("href")||"";if(h.charAt(0)==="#"){e.preventDefault();var d=h.length>1&&document.getElementById(decodeURIComponent(h.slice(1)));if(d)d.scrollIntoView({behavior:"smooth",block:"start"});return;}if(/^https?:/i.test(h))a.target="_blank";});</script>`;

// Página completa para o iframe: tutoriais escritos como fragmento ganham o esqueleto do documento.
// O Cajupe é sempre claro: data-theme="light" desliga o tema escuro dos tutoriais que o têm.
export function documentoTutorial(conteudo) {
  const html = String(conteudo || "");
  if (/^\s*<!doctype/i.test(html) || /<html[\s>]/i.test(html)) {
    const claro = /<html[^>]*\sdata-theme=/i.test(html)
      ? html
      : html.replace(/<html(?=[\s>])/i, '<html data-theme="light"');
    return /<\/body>/i.test(claro)
      ? claro.replace(/<\/body>/i, `${SCRIPT_LINKS}</body>`)
      : claro + SCRIPT_LINKS;
  }
  return `<!doctype html><html lang="pt-BR" data-theme="light"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta name="color-scheme" content="light"></head><body>${html}${SCRIPT_LINKS}</body></html>`;
}

function caminhoNormalizado(valor) {
  return String(valor || "")
    .split("?")[0]
    .replace(/\/+$/, "")
    .toLowerCase();
}

function listaJson(valor) {
  if (Array.isArray(valor)) return valor;
  try {
    const lista = JSON.parse(valor || "[]");
    return Array.isArray(lista) ? lista : [];
  } catch (e) {
    return [];
  }
}

export function passosDoProcesso(processo) {
  return processo && Array.isArray(processo.steps)
    ? processo.steps
    : listaJson(processo && processo.stepsJson);
}

// Processo do Siga ligado à tela: pelas rotas relacionadas ou pelas rotas dos passos,
// por nome ou caminho, a mesma regra do "Tela atual" do Caju.
export function processoDaTela(processo, rota = {}) {
  const caminho = caminhoNormalizado(rota.path);
  const passos = passosDoProcesso(processo);
  return [
    ...listaJson(processo && processo.requiredRoutes),
    ...passos.map((passo) => passo && passo.routeName),
    ...passos.map((passo) => passo && passo.routePath),
  ]
    .filter(Boolean)
    .some(
      (candidata) =>
        candidata === rota.name || caminhoNormalizado(candidata) === caminho
    );
}

export function formatarTamanho(bytes) {
  const valor = Number(bytes) || 0;
  if (valor < 1024) return `${valor} B`;
  if (valor < 1024 * 1024) return `${(valor / 1024).toFixed(0)} KB`;
  return `${(valor / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`;
}
